export default {
  container: {
    fontSize: ['16px', '16px'],
    margin: '0 auto',
  },
  imageContainer: {
    height: '100%',
    position: 'relative',
  },
  headerImage: {
    width: '100vw',
    objectFit: 'cover',
    height: ['331px', '331px', '599px'],
  },
}
